import { EventAction } from 'Pages/EventDetailPage/Redux/actions';

export interface IEvent {
  event: Julius.Website.EventDetailViewModel;
  isFetching: boolean;
  isFetchFailed: boolean;
}

const initialEvent: IEvent = {
  event: null,
  isFetching: false,
  isFetchFailed: false,
};

function event(state: IEvent = initialEvent, action: EventAction): IEvent {
  switch (action.type) {      
    case 'SET_EVENT':
      return {
        ...state,
        event: action.event,
        isFetching: false,
        isFetchFailed: false,
      };

    case 'SET_IS_FETCHING_EVENT':
      return {
        ...state,
        isFetching: true,
      };
    
    case 'SET_FETCH_EVENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    default:
      return state;
  }
}

export default event;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/Redux/reducer.tsx